module.exports = "<h1 class=\"gw-titles-title\" ng-class=\"{ 'gw-titles-title_offset': hasOffset }\">\r\n    <ng-transclude></ng-transclude>\r\n</h1>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/titles/templates/Title.html
// module id = 607
// module chunks = 0